'use strict';

const BaseModule = require('_base/base');

class AnimatedModule extends BaseModule {
  preInit() {
    this.FORCED_ANIMATION_FRAMELENGTH = 30;
    this.FORCED_ANIMATION_DURATION = 300;
  }

  postInit() {
    this.parseAnimation();
    this.initAnimation();
  }

  register() {
    this.$el.parent().trigger('animatedModuleInit', this);
  }

  initAnimation() {}

  parseAnimation() {
    this.animation = this.$el.animationsObject();

    for (let attr in this.animation) {
      if (attr.indexOf('-') > -1) {
        const attrArray = attr.split('-');

        this.animation[attrArray[0]] = this.animation[attrArray[0]] || {};
        this.animation[attrArray[0]][attrArray[1]] = this.animation[attr];
      }
    }

    this.animation.fromAnchorId = parseInt(this.animation.fromanchor, 10) || 1;
    this.animation.tillAnchorId = parseInt(this.animation.tillanchor, 10);

    this.animation.fromPosition = parseInt(this.animation.fromposition, 10);
    this.animation.tillPosition = parseInt(this.animation.tillposition, 10);
  }

  setAnchors(anchors) {
    const { fromPosition, fromAnchorId, tillPosition, tillAnchorId } = this.animation

    const anchorFrom = anchors[fromAnchorId - 1]

    if (!anchorFrom && !fromPosition) console.error('Animation FROM is missing', this.animation)
    if (anchorFrom) this.animation.fromPosition = anchorFrom.originalTrigger

    const anchorTill = anchors[tillAnchorId - 1]

    if (!anchorTill && !tillPosition) console.error('Animation TILL is missing', this.animation)
    if (anchorTill) this.animation.tillPosition = anchorTill.originalTrigger
  }

  animate(position, forcedAnchorId) {
    if (forcedAnchorId) {
      this.forcedAnimate(forcedAnchorId);
    } else {
      this.standardAnimate(position);
    }
  }

  standardAnimate(position) {
    this.progress = (position - this.animation.fromPosition) /
      (this.animation.tillPosition - this.animation.fromPosition);

    if (this.progress < 0) {
      this.progress = 0;
    }

    if (this.progress > 1) {
      this.progress = 1;
    }

    this.draw(this.progress);
  }

  forcedAnimate(forcedAnchorId) {
    this.oldProgress = this.progress
    this.progress = (forcedAnchorId - this.animation.fromAnchorId) /
      (this.animation.tillAnchorId - this.animation.fromAnchorId)

    const progressDifference = this.progress - this.oldProgress
    const absProgressDifference = Math.abs(progressDifference)
    const direction = progressDifference > 0 ? 1 : -1

    clearInterval(this.autoProgressIntervalID)

    if (progressDifference) {
      let offset = 0
      let tick = absProgressDifference / this.FORCED_ANIMATION_FRAMELENGTH

      this.autoProgressIntervalID = setInterval(() => {
        const progress = Math.round((this.oldProgress + offset * direction) * 1000) / 1000
        offset += tick

        this.draw(progress)

        if (offset - absProgressDifference > 0.001) {
          clearInterval(this.autoProgressIntervalID)
        }
      }, this.FORCED_ANIMATION_DURATION / this.FORCED_ANIMATION_FRAMELENGTH)
    }
  }

  draw() {}
}

module.exports = AnimatedModule;
